export const iconFontAwesomeCodingBars = (
	<i className="fa-solid fa-bars"></i>
);
